import React from "react";

// use this inside forms to separate different sections
const Legend = ({ children, className }) => (
  <legend className={`text-gray-900 my-2 text-lg ${className ?? ""}`}>{children}</legend>
);

export default Legend;
